import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import {
  FlexBoxLeftCenter,
  FlexBoxCenter,
  BoxFlexCenterStart,
  BoxTable,
  BoxTableRow,
  BoxTableCell
} from '../customComponent/box';

import * as basicConstants from '../../constants/basic';

import theme from '../../theme';

const LinkAdAccount = (props) => {
  const { currentData, handleLinkAdAccount, triggerSubmit } = props;

  // console.log(currentData);

  useEffect(() => {
    if (!triggerSubmit) return;

    if (currentData.adAccounts.length > 1) {
      const temp = currentData.adAccounts
        .map(el => el.adAccountId)
        .join(',');

      handleLinkAdAccount(temp);
    } else {
      handleLinkAdAccount(currentData.adAccounts[0].adAccountId);
    }

  }, [triggerSubmit])

  // console.log('currentData', currentData);

  return (
    <>
      <Box sx={{ px: '24px' }} >
        <Typography><FormattedMessage id="addAccount.modal.checkAuthorize" values={{ media: currentData.media }} /></Typography>
        {
          currentData.adAccounts.length > 1 &&
          <>
            <BoxTable sx={{ mt: '16px', color: theme.palette.system.main }}>
              {
                currentData.adAccounts.map(el => {
                  return (
                    <BoxTableRow>
                      <BoxTableCell>{el.adAccountId}</BoxTableCell>
                      <BoxTableCell>{el.adAccountName}</BoxTableCell>
                    </BoxTableRow>
                  )
                })
              }
            </BoxTable>
          </>
        }
        {
          currentData.adAccounts.length === 1 &&
          <Typography variant="body2" sx={{ mt: '16px', color: theme.palette.system.main }}>
            {`${currentData.adAccounts[0].adAccountId}　${currentData.adAccounts[0].adAccountName}`}
          </Typography>
        }
      </Box>
    </>
  )

}

export default LinkAdAccount;